
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultations/topic/[slug]",
      function () {
        return require("private-next-pages/consultations/topic/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultations/topic/[slug]"])
      });
    }
  